import Period from "./Period";
class Tenor {
    nonCall;
    perpetual;
    qualifier;
    value;
    constructor(response) {
        this.nonCall = response.nonCall !== undefined ? new Period(response.nonCall) : undefined;
        this.perpetual = response.perpetual;
        this.qualifier = response.qualifier;
        this.value = response.value !== undefined ? new Period(response.value) : undefined;
    }
    print() {
        const text = [];
        if (this.qualifier === 'LONG') {
            text.push('Long ');
        }
        else if (this.qualifier === 'SHORT') {
            text.push('Short ');
        }
        if (this.value !== undefined) {
            text.push(this.value.periodMultiplier.toString());
        }
        else if (this.perpetual) {
            text.push('Perp');
        }
        if (this.nonCall?.periodMultiplier !== undefined) {
            text.push(`NC${this.nonCall.periodMultiplier.toString()} `);
        }
        else if (this.value?.period !== undefined) {
            text.push(this.value.period);
        }
        return text.join('');
    }
}
export default Tenor;
